import React from 'react';
import { cn } from '../lib/utils';

const TemplatesLayout = ({ title = 'Templates', description, filters, children, className }) => (
  <section className={cn('flex min-h-0 min-w-0 flex-col gap-4 px-3 py-4 sm:px-4 sm:py-5 lg:gap-6 lg:px-8 lg:py-6', className)}>
    <div className="flex flex-col gap-2">
      <div>
        <h1 className="text-xl font-semibold text-[var(--tg-text-primary)] sm:text-2xl">{title}</h1>
        {description && <p className="text-sm text-[var(--tg-text-muted)]">{description}</p>}
      </div>
      {filters && <div className="flex flex-wrap gap-3">{filters}</div>}
    </div>
    <div className="templates-layout__content min-h-0 min-w-0 flex-1 overflow-hidden rounded-2xl border border-[var(--tg-border-soft)] bg-[var(--tg-surface)] p-2 sm:rounded-3xl sm:p-4">
      {children}
    </div>
  </section>
);

export default TemplatesLayout;
